module.exports = __webpack_public_path__ + "img/content.ad1fb50b.png";